import React from 'react';
import { SvgIconProps } from '@mui/material';

import { SvgIcon } from '../svg-icon';

function Logout({ fill, stroke, ...props }: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H14C15.1046 21 16 20.1046 16 19V14H10C8.89543 14 8 13.1046 8 12C8 10.8954 8.89543 10 10 10H16V5C16 3.89543 15.1046 3 14 3H6Z"
        fill="currentColor"
      />
      <path
        d="M16.7075 16.3C17.0975 16.69 17.7275 16.69 18.1175 16.3L21.7075 12.71C22.0975 12.32 22.0975 11.69 21.7075 11.3L18.1175 7.70997C17.9306 7.52271 17.677 7.41748 17.4125 7.41748C17.148 7.41748 16.8943 7.52271 16.7075 7.70997C16.3175 8.09997 16.3175 8.72997 16.7075 9.11997L18.5875 11.01H9.91748C9.36748 11.01 8.91748 11.46 8.91748 12.01C8.91748 12.56 9.36748 13.01 9.91748 13.01H18.5875L16.7075 14.89C16.3175 15.28 16.3275 15.92 16.7075 16.3Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export { Logout };
